function te(i,e){void 0;}
function email(){
	var view = {
		setEventListeners:function(){
            // clear any old cookies
            POP.clearCookies();

			$('#loginFormEmail').submit(this.validateForm);
            $('#resetForm').submit(this.passwordReset);

			// toggle views
			$('#trigger-reset').click(this.showPasswordReset);
			$('#trigger-login').click(this.showLogin);
		},

		showPasswordReset: function(e) {
			e.preventDefault();

			$('#loginFormEmail').addClass('hidden');
			$('#resetForm').removeClass('hidden');
			$('#small-form-heading').text('RESET YOUR EMAIL PASSWORD');
		},

		showLogin: function(e) {
			e.preventDefault();

			$('#resetForm').addClass('hidden');
			$('#loginFormEmail').removeClass('hidden');
			$('#small-form-heading').text('LOGIN TO EMAIL');
		},

		loginHandler:function(e) {
			var $form = $('#loginFormEmail');

			void 0;


			// successful password reset
            if (e.code == 202) {
            	// trigger login form and success message
            	view.showMessage('Your POP email password has been updated. Please wait while we redirect you to the login page.', true, $form);
            	
            	setTimeout(function() {
            		window.location.href = '/email'
            	}, 2000);

            	return;
            }

            if (typeof e.msg != "undefined") {
                view.showMessage(e.msg, e.code == 200, $form);
            } else {
                view.showMessage(POP.messages.loggedin, e.code == 200, $form);
            }

			if (e.code == 200) {
				POP.clearCookies();
                $.cookie('pop_weasel', e.data.token, { path:'/', domain:'.pop.co' });
                $.cookie('pop_domain', e.data.email.split('@')[1], { path:'/', domain:'.pop.co' });

                // handle based on the type of login
				if (e.data.gapps_login === true) {
					if (typeof e.data.url != 'undefined' && e.data.url.length) {
						view.redirect(e.data.url);
					} else if (POP.loginRedirect) {
						view.redirect(POP.loginRedirect);
					} else {
						view.redirect($.url(window.location.href).param('r'));
					}
				} else {
					void 0;

					// lets post to data.redirect, passing data.params
					var form = '<form action="' + e.data.url + '" method="post" id="formpost">';
					for (key in e.data.params) {
						form += '<input type="text" name="' + key  + '" value="' + e.data.params[key] + '" />';
					}
					form += '</form>';
					$('body').append($(form));
					$('#formpost').submit();
				}
			} else {
				// console.log("login failed", e);
				if (typeof e.msg != "undefined") {
					view.showMessage(e.msg, false, $form);
				} else {
					view.showMessage(POP.messages.genericError, false, $form);
				}
			}
		},

		passwordResetHandler: function(response) {
			var $form = $('#resetForm');

			// console.log(response);
			POP.Ajax.done($form.find('button'));

			if (typeof response.msg != "undefined") {
				if (response.code == 200) {
					view.showMessage(response.msg, true, $form);
				} else {
					view.showMessage(response.msg, false, $form);
				}
			} else {
				view.showMessage(POP.messages.genericError, false, $form);
			}
		},

		validateForm: function(e) {
			var $form = $(this);

			e.preventDefault();

			// clean our slate
			view.clearMessage(false, $form);

			// validate the form
			$form.find('input').each(view.validateText);

			if ($('input.invalid1', $form).length == 0) {
				view.submitForm($form, window.tempCode ? '/user/resetpasswordemail' : '/user/email/', view.loginHandler);
			}
		},

		/**
		 * Handle the password reset.
		 */
		passwordReset: function(e) {
			var $form = $(this);

			var elem = $form.find('button');
			var email = $form.find('input[name=email]').val();

			e.preventDefault();

			// clean our slate
			view.clearMessage(true, $form);

			// validate just email/cell
			if (email.length < 1) {
				view.showMessage("Please enter your email address.", false, $form);
			} else {
				view.submitForm($form, '/user/forgot/email/', view.passwordResetHandler);
			}
		},

		submitForm: function($form, url, handler) {
			var data = $form.serialize(),
				$btn = $form.find('button[type=submit]');

			POP.Ajax.submitting($btn);

			$.ajax({
				type: "POST",
				url: POP.apiBaseUrl + url,
				data: data,
				success: handler,
				error: function() {
					POP.Ajax.error($form.find('button[type=submit]'));
					handler.apply(this, [{code:555}])
				},
				headers: {'X-Requested-With': 'XMLHttpRequest'},
				crossDomain:true,
				dataType:"json"
			}).done(function(resp) {
				POP.Ajax.done($form.find('button[type=submit]'), resp);
			});
		},

		redirect: function(redirect){
			if(typeof redirect == 'undefined' || !redirect || redirect == ''){
				window.location.href = '/panel'
			} else {
				window.location.href = redirect;
			}
		},

		showMessage: function(message, success, $form) {
            var $alert = $form.find('.alert');

            // Clear original content & add new message
            view.clearMessage(success, $form);

			$alert.html(message);

			// Define success / fail styles
			if (success === true) {
				$alert.addClass('alert-success');
			} else {
                $alert.addClass('alert-danger');
            }

            // Display message 
            if ($alert.is(':visible')) {
            	return;
            } else {
            	$alert.removeClass('hidden').slideDown();	
            }
            
            // POP.scrollTo($alert, true);
			view.scrollToElem($alert);
		},

		clearMessage: function(success, $form) {
			var $alert = $form.find('.alert');
			if (success === true) {
				$alert
					.slideUp()
					.addClass('hidden')
					.removeClass('alert-danger')
					.removeClass('alert-success')
					.html('');
			} else {
				$alert
					.removeClass('alert-danger')
					.html('');
			}
        },

		validateText: function(i,elem){
			var elem = $(elem);
			var input = elem.val();

			switch(elem.attr('name').toLowerCase()){
				case 'email':
					if (input.length != 0) {
						view.makeValid(elem, true);
					} else {
						view.makeValid(elem, false);
					}
					break;
				case 'password':
					if (input.length >= 4) {
						view.makeValid(elem, true);
					} else {
						view.makeValid(elem, false);
					}
					break;
			}
		},

		makeValid: function(elem, valid) {
			if (valid == true) {
				elem.addClass("valid1");
				elem.removeClass("invalid1");
			} else {
				elem.addClass("invalid1");
				elem.removeClass("valid1");
			}
		},

		scrollTo: function(pos) {
			$('html, body').animate({scrollTop: (pos-25)}, 700);
		},

		scrollToElem: function(elem) {
			var windowHeight = $(window).height();
			var scrollTop = $(document).scrollTop();
			var windowBottom = windowHeight + scrollTop;
			var elemTop = $(elem).offset().top;
			if (elemTop < scrollTop || elemTop > windowBottom){
				view.scrollTo(elemTop);
			}
		}
	};

	function start(){
		view.setEventListeners();

		$('[type=text]').eq(0).focus();

		var r = $.url(window.location.href).param('r');
		if (typeof r == 'undefined' || r == '' || r == null) {
			// console.log('you will not be redirected!');
		} else {
			view.showMessage('Please login first', false, $('#loginFormEmail'));
		}
	}

	start();
}
